import { create } from 'zustand';

export const useUnSaveChanges = create((set) => ({
  unSaveChange: null,
  updateUnSaveChange: (option: string) => set(() => ({ unSaveChange: option }))
}));

export const usePageSelected = create((set) => ({
  page: 'overview',
  updatePage: (pageSelected: string) => set(() => ({ page: pageSelected }))
}));

export const useColumnView = create((set) => ({
  view: 'empty',
  updateView: (viewSelected: string) => set(() => ({ view: viewSelected }))
}));

export const useRowSelected = create((set) => ({
  row: null,
  updateRowSelected: (rowSelected: any) => set(() => ({ row: rowSelected }))
}));

export const useConfirmModal = create((set) => ({
  isConfirmClicked: false,
  updateIsConfirmClicked: (isConfirmed: any) => set(() => ({ isConfirmClicked: isConfirmed }))
}));

export const useScreenDimensions = create((set) => ({
  screenSizes: {
    browserSize: 100,
    screenHeight: 91.25
  },
  updateScreenSizes: (data: any) => set(() => ({ screenSizes: data }))
}));

export const usePreRowSelected = create((set) => ({
  rowPreSelected: null,
  updateRowPreSelected: (row: any) => set(() => ({ rowPreSelected: row }))
}));

export const useGridApiInfo = create((set) => ({
  data: null,
  update: (info: any) => set(() => ({ data: info }))
}));

export const useSegmentsGridApiInfo = create((set) => ({
  data: null,
  update: (info: any) => set(() => ({ data: info }))
}));

export const useValuesSorted = create((set) => ({
  valuesSorted: null,
  updateValuesSorted: (arr: any) => set(() => ({ valuesSorted: arr }))
}));

export const useFileUploadedState = create((set) => ({
  fileUploadedState: false,
  setFileUploadedState: (state: boolean) => set(() => ({ fileUploadedState: state }))
}));

export const useFileAttached = create((set) => ({
  file: '',
  setFileAttached: (name: string) => set(() => ({ file: name }))
}));

export const useGroupInfoSelected = create((set) => ({
  groupInfo: {},
  setGroupInfo: (info: any) => set(() => ({ groupInfo: info }))
}));

export const useStoreAllGridChanges = create((set) => ({
  gridChanges: [],
  setGridChanges: (changes: any) => set(() => ({ gridChanges: changes }))
}));

export const useInitialSettingsData = create((set) => ({
  settingsDataInitial: [],
  setSettingsDataInitial: (data: any) => set(() => ({ settingsDataInitial: data }))
}));

export const useCancelFocusModal = create((set) => ({
  isCancelModal: false,
  setIsCancelModal: (isCancel: boolean) => set(() => ({ isCancelModal: isCancel }))
}));

export const useStoreGroupedViews = create((set) => ({
  groupedViews: [],
  setGroupedViews: (changes: any) => set(() => ({ groupedViews: changes }))
}));

export const useGroupSelected = create((set) => ({
  groupSelected: null,
  setGroupSelected: (group: string) => set(() => ({ groupSelected: group }))
}));

export const useFinishRollback = create((set) => ({
  finish: false,
  setFinish: (isFinished: boolean) => set(() => ({ finish: isFinished }))
}));

export const useAddToGroup = create((set) => ({
  addToGroup: 0,
  setAddToGroup: (add: number) => set(() => ({ addToGroup: add }))
}));

export const useAddToGroupList = create((set) => ({
  groupRollbackList: {},
  setgroupRollbackList: (group: any) => set(() => ({ groupRollbackList: group }))
}));

export const useOptionSelectedPopup = create((set) => ({
  optionSelected: 0,
  setOptionSelected: (option: number) => set(() => ({ optionSelected: option }))
}));

export const useResetSegmentsGrid = create((set) => ({
  resetSegments: false,
  setResetSegments: (reset: boolean) => set(() => ({ resetSegments: reset }))
}));

export const useSaveSegmentsGrid = create((set) => ({
  saveSegments: false,
  setSaveSegments: (save: boolean) => set(() => ({ saveSegments: save }))
}));

export const useUpdateSegmentsGrid = create((set) => ({
  updateSegments: null,
  setUpdateSegments: (update: any) => set(() => ({ updateSegments: update }))
}));

export const useShowLoaderGridSettings = create((set) => ({
  showLoader: false,
  setShowLoader: (loading: boolean) => set(() => ({ showLoader: loading }))
}));

export const useClearSelectionBreakdown = create((set) => ({
  isClearBreakdownSelected: false,
  setIsClearBreakdownSelected: (selectec: boolean) =>
    set(() => ({ isClearBreakdownSelected: selectec }))
}));

export const useCancelModalUnsaveChanges = create((set) => ({
  isCanceled: false,
  setIsCanceled: (cancel: boolean) => set(() => ({ isCanceled: cancel }))
}));

export const useConfirmModalUnsaveChanges = create((set) => ({
  isConfirmed: false,
  setIsConfirmed: (confirm: boolean) => set(() => ({ isConfirmed: confirm }))
}));

export const useStorePageQueu = create((set) => ({
  pageQueu: null,
  setPageQueu: (page: string) => set(() => ({ pageQueu: page }))
}));

export const useStorePageLoaded = create((set) => ({
  pageLoaded: null,
  setPageLoaded: (page: string) => set(() => ({ pageLoaded: page }))
}));

export const useSentLoader = create((set) => ({
  sentLoader: false,
  setSentLoader: (loader: boolean) => set(() => ({ sentLoader: loader }))
}));

export const useFinishLoader = create((set) => ({
  finishLoader: false,
  setFinishLoader: (loader: boolean) => set(() => ({ finishLoader: loader }))
}));

export const useShowModalByWrongGroup = create((set) => ({
  showModal: null,
  setShowModal: (show: boolean) => set(() => ({ showModal: show }))
}));

export const useIsSaveChangesEnabled = create((set) => ({
  isEnabled: false,
  seIsEnabled: (enable: boolean) => set(() => ({ isEnabled: enable }))
}));

export const useLastSettingsData = create((set) => ({
  settings: [],
  setSettings: (data: any) => set(() => ({ settings: data }))
}));

export const useMakeChangesSegments = create((set) => ({
  changed: false,
  setChanged: (change: boolean) => set(() => ({ changed: change }))
}));

export const useShowModalEmpty = create((set) => ({
  showModalEmpty: false,
  setShowModalEmpty: (show: boolean) => set(() => ({ showModalEmpty: show }))
}));

export const useShowNoSavedChangesModal = create((set) => ({
  showModal: false,
  setShowModal: (show: boolean) => set(() => ({ showModal: show }))
}));

export const useRowSelectedChanges = create((set) => ({
  changed: false,
  setChanged: (wasChanged: boolean) => set(() => ({ changed: wasChanged }))
}));

export const useFireSegmentsCancel = create((set) => ({
  firePageUpdated: false,
  setFirePageUpdated: (update: boolean) => set(() => ({ firePageUpdated: update }))
}));

export const useMultipleChoiceUpdates = create((set) => ({
  updated: false,
  setUpdated: (isChanged: boolean) => set(() => ({ updated: isChanged }))
}));

export const useResetOptionMultiplechoise = create((set) => ({
  isReset: false,
  setIsReset: (reset: boolean) => set(() => ({ isReset: reset }))
}));

export const useExcludedChanged = create((set) => ({
  changed: false,
  setChanged: (change: boolean) => set(() => ({ changed: change }))
}));

export const useUniqueValuesUpdated = create((set) => ({
  isUpdated: false,
  setIsUpdated: (update: boolean) => set(() => ({ isUpdated: update }))
}));

export const useStoreNewUniqueValues = create((set) => ({
  uniqueValues: [],
  setUniqueValues: (values: any) => set(() => ({ uniqueValues: values }))
}));

export const useStoreNewUniqueValuesRollback = create((set) => ({
  uniqueValuesRollback: [],
  setUniqueValuesRollback: (values: any) => set(() => ({ uniqueValuesRollback: values }))
}));

export const useDataTypeSelected = create((set) => ({
  dataType: '',
  setDataType: (type: string) => set(() => ({ dataType: type }))
}));

export const useDateDataTypeStored = create((set) => ({
  dateStored: [],
  setDateStored: (array: any) => set(() => ({ dateStored: array }))
}));

export const useNumberDataTypeDecimalStored = create((set) => ({
  decimalStored: [],
  setDecimalStored: (array: any) => set(() => ({ decimalStored: array }))
}));

export const useNumberDataTypeDisplayStored = create((set) => ({
  displayStored: [],
  setDisplatStored: (array: any) => set(() => ({ displayStored: array }))
}));

export const useCancelDisplayDataType = create((set) => ({
  isCanceled: false,
  setIsCanceled: (cancel: boolean) => set(() => ({ isCanceled: cancel }))
}));

export const useGetMenuData = create((set) => ({
  dataReceived: false,
  setDataReceived: (received: boolean) => set(() => ({ dataReceived: received }))
}));

export const useCancelChangesButton = create((set) => ({
  isCanceled: false,
  setIsCanceled: (cancel: boolean) => set(() => ({ isCanceled: cancel }))
}));

export const usePopUpDataTypeState = create((set) => ({
  isOpen: [{ view: undefined, isOpened: false }],
  setIsOpen: (state: any) => set(() => ({ isOpen: state }))
}));

export const useHideDropDownTypes = create((set) => ({
  hide: false,
  setHide: (hide: boolean) => set(() => ({ hide: hide }))
}));

export const useOnlyViewsIncluded = create((set) => ({
  views: undefined,
  setViews: (data: any) => set(() => ({ views: data }))
}));

export const useIsScrollBar = create((set) => ({
  scroll: false,
  setScroll: (scrolling: boolean) => set(() => ({ scroll: scrolling }))
}));

export const useContractTextAnalyzer = create((set) => ({
  contract: false,
  setContract: (loader: boolean) => set(() => ({ contract: loader }))
}));

export const useShowTextAnalyzerModal = create((set) => ({
  open: false,
  setOpen: (open: boolean) => set(() => ({ open: open }))
}));

export const useTextAnalyzerSteps = create((set) => ({
  step: 0,
  setStep: (open: number) => set(() => ({ step: open }))
}));

export const useTextAnalyzerTabs = create((set) => ({
  activeTab: 0,
  setActiveTab: (open: number) => set(() => ({ activeTab: open }))
}));

export const useShowTextAnalyzerTabs = create((set) => ({
  showTabs: false,
  setShowTabs: (open: boolean) => set(() => ({ showTabs: open }))
}));

export const useEstimatedTimeTextAnalyzer = create((set) => ({
  time: 0,
  setTime: (num: number) => set(() => ({ time: num }))
}));

export const useRemainingTimeTextAnalyzer = create((set) => ({
  time: 0,
  setTime: (num: number) => set(() => ({ time: num }))
}));

export const useProgressTimeTextAnalyzer = create((set) => ({
  time: 0,
  setTime: (num: number) => set(() => ({ time: num }))
}));

export const useExtractColumnSuccess = create((set) => ({
  sucess: false,
  setSucess: (sucess: boolean) => set(() => ({ sucess: sucess }))
}));
